<template>
  <div class="STree">
      <!-- <el-tree

        ref="tree"
        :data="data"
        show-checkbox
        node-key="id"
        :filter-node-method="filterNode"
        highlight-current
        :props="defaultProps"
        @check-change="handleCheckChange"
        empty-text=""
      /> -->
      <vue-easy-tree   
      ref="tree"
      show-checkbox
      node-key="id"
      height="300px"
      :data="data"
        default-expand-all
      :props="defaultProps"
      style="width:400px"
        highlight-current
           @check-change="handleCheckChange"
             empty-text=""
            :filter-node-method="filterNode"
    ></vue-easy-tree>
  </div>
</template>

<script>
import VueEasyTree from "@wchbrad/vue-easy-tree";

// import "@wchbrad/vue-easy-tree/src/assets/index.less";
// import "@wchbrad/vue-easy-tree/src/assets/index.scss"
export default {
  name: 'STreeNew',
  components:{
   VueEasyTree
  },
  props: {
    tempText:{
        type:String,
        default:''
    },
    value: {
      type: Array,
      default() {
        return []
      }
    },
    isShowFilter: {
      type: Boolean,
      default() {
        return true
      }
    },
    data: {
      type: Array,
      default() {
        return []
      }
    },
    checkedType: {
      type: String,
      default() {
        return ''
      }
    },
    defaultProps:{
      type:Object,
      default(){
        return {
        children: 'children',
        label: 'name',
        }
      }
    }
  },
  data() {
    return {
      filterText: '',
      // defaultProps: {
      //   children: 'children',
      //   label: 'name',
      //   //  disabled:function(data,node){
      //   //                 if(data.children&&data.children.length>0){
      //   //                     return true            
      //   //                 }else{
      //   //                     return false            
      //   //                 }
      //   //         }    
      // },
        props: {
        label: "name",
        children: "children",
      },
      treeData: [],
      ids:[]
    }
  },
  computed: {},
  watch: {
    tempText(val) {
             if(val){
      this.$refs.tree.filter(val)
             }
             else{
                    this.$refs.tree.filter(val)
             }
      // this.$refs.veTree.filter(val)
    },
    value(v, a) {
      this.setValue()
    }
  },
  created: function() {

  },
  mounted() {
    console.log(this.data)
    this.setValue()
  },
  beforeUpdate() {
    this.setValue()
  },
  methods: {
    handleCheckChange(data, checked, indeterminate) {
      this.getCheckedIds()
      this.$emit('check',this.ids)
      console.log(this.ids,'ids')
      // const ids = this.getCheckedIds()
      // this.ids.push(data.id)
      // this.$emit('input', this.ids)
    },
    getCheckedIds() {
      const ids = []
      const nodes = this.$refs.tree.getCheckedNodes(true, false)
      for (var i = 0; i < nodes.length; i++) {
        const node = nodes[i]
        if (!node.noData) {
          if (this.checkedType) {
            if (node.attrs.type === this.checkedType) {
              ids.push(node.id)
            }
          } else {
            ids.push(node.id)
          }
        }
      }
        this.ids=ids
    },

    resetChecked() {
      this.$refs.tree.setCheckedKeys([])
    },
    setValue(val) {
      let cks = val
      if (!cks) {
        const { value } = this
        cks = value
      }
      this.$refs.tree.setCheckedKeys(cks)
      this.$emit('input', cks)
    },
    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    }
  }
}
</script>

<style scoped lang="less">
@import "./index.less";
</style>



// WEBPACK FOOTER //
// src/components/GoodStree/index.vue